import React from "react";
import {
  Box,
  Button,
  Card,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";

const SwapButton = ({ handleCurrencySwap, colors }) => {
  return (
    <Grid
      container
      item
      md={2}
      xs={2}
      justifyContent={"center"}
      alignItems={"center"}
      flexDirection={"center"}
    >
      <Button
        disableRipple={true}
        sx={{
          ":hover": {
            backgroundColor: "transparent",
            borderRadius: "100%",
          },
        }}
        onClick={handleCurrencySwap}
      >
        <Box
          sx={{
            width: "45px",
            height: "45px",
            background: colors.lightOrange,
            borderRadius: "100%",
          }}
        >
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            flexDirection={"column"}
            marginTop={1.5}
          >
            <SwapHorizIcon color="warning" />
          </Grid>
        </Box>
      </Button>
    </Grid>
  );
};

export default SwapButton;
